import { render } from "./BoxComponent.vue?vue&type=template&id=7069b4f1&scoped=true"
import script from "./BoxComponent.vue?vue&type=script&lang=js"
export * from "./BoxComponent.vue?vue&type=script&lang=js"

import "./BoxComponent.vue?vue&type=style&index=0&id=7069b4f1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7069b4f1"]])

export default __exports__